import React, { useState, useEffect } from "react";
import { fetchAll } from "../utils/fetchResources";
import { fetchOne } from "../utils/fetchResources";
import { Link, useParams, Prompt } from "react-router-dom";
import {
	Typography,
	TextField,
	Button,
	useTheme,
	FormControl,
	InputLabel,
	Select,
	MenuItem,
	Grid,
	Hidden,
	Card,
	CardContent,
	FormGroup,
	FormControlLabel,
	Switch,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { useSnackbar } from "notistack";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import Editor from "ckeditor5-custom-build/build/ckeditor";
import { onReadyCKE, CKEconfig } from "../config/CKE";

const useStyles = makeStyles((page) => ({
	form: {
		width: "100%", // Fix IE 11 issue.
	},
	submit: {
		margin: page.spacing(2, 0, 1),
	},
}));

export default function PagesEdit(props) {
	const muiPage = useTheme();
	const { id } = useParams();
	const classes = useStyles();
	const [page, setPage] = useState({});
	const [sites, setSites] = useState([]);
	const [loading, setLoading] = useState(true);
	const [unsaved, setUnsaved] = useState(false);
	const { enqueueSnackbar } = useSnackbar();

	useEffect(() => {
		(async () => {
			await fetchAll("sites", setSites, "name");
			setLoading(false);
		})();
	}, []);

	useEffect(() => {
		(async () => {
			await fetchOne("pages", id, setPage);
			setLoading(false);
		})();
	}, [id]);

	const onChange = (e) => {
		setPage({ ...page, [e.target.name]: e.target.value });
		setUnsaved(true);
	};

	const onChangeSite = (e) => {
		setPage({ ...page, [e.target.name]: e.target.value });
		setUnsaved(true);
	};

	const onChangeContent = (e, editor) => {
		const data = editor.getData();
		setPage({ ...page, content: data });
		setUnsaved(true);
	};

	const onChangePublished = (e) => {
		setPage({ ...page, [e.target.name]: e.target.checked });
		setUnsaved(true);
	};

	const onSubmit = (e) => {
		e.preventDefault();
		fetch(`${process.env.REACT_APP_API_URL}/pages/${id}`, {
			method: "PUT",
			credentials: "include",
			body: JSON.stringify(page),
			headers: { "Content-Type": "application/json" },
		})
			.then((res) => res.json())
			.then((data) => {
				if (data.success) {
					setUnsaved(false);
					enqueueSnackbar("Page updated successfully!", {
						variant: "success",
					});
				} else {
					console.log(data);
					const errorArray = data.error.split(",");
					errorArray.forEach((error) => {
						enqueueSnackbar(`${error}`, { variant: "error" });
					});
				}
			});
	};

	if (loading) {
		return <div>Loading...</div>;
	}

	return (
		<>
			<Prompt
				when={unsaved}
				message="You have unsaved changes. Are you sure you want to leave?"
			/>
			<Typography component="h1" variant="h4">
				Edit Page: {page.title}
			</Typography>
			<form className={classes.form} onSubmit={onSubmit}>
				<Grid container spacing={2}>
					<Grid item xs={12} sm={12} md={9}>
						<TextField
							variant="outlined"
							margin="normal"
							fullWidth
							id="title"
							label="Page Title"
							name="title"
							size="small"
							value={page.title}
							autoFocus
							required
							onChange={onChange}
						/>
						<TextField
							variant="outlined"
							margin="normal"
							fullWidth
							id="name"
							label="Slug"
							name="slug"
							size="small"
							value={page.slug}
							autoFocus
							required
							onChange={onChange}
						/>
						<FormControl
							fullWidth
							size="small"
							margin="normal"
							variant="outlined"
							className={classes.formControl}
							required
							name="site"
						>
							<InputLabel id="site-theme-label">Site</InputLabel>
							<Select
								inputProps={{ name: "site" }}
								value={page.site}
								onChange={onChangeSite}
								label="site"
							>
								<MenuItem value="">
									<em>None</em>
								</MenuItem>
								{sites &&
									sites.map((site, index) => {
										return (
											<MenuItem key={index} value={site.id}>
												{site.name}
											</MenuItem>
										);
									})}
							</Select>
						</FormControl>
						<p className={classes.CKElabels}>Content:</p>
						<CKEditor
							onReady={(editor) => {
								onReadyCKE(editor);
							}}
							editor={Editor}
							onChange={onChangeContent}
							data={page.content}
							config={CKEconfig("Content...")}
						/>
						<Button
							type="submit"
							fullWidth
							variant="contained"
							color="primary"
							className={classes.submit}
						>
							Save
						</Button>
					</Grid>
					<Grid item xs={12} sm={12} md={3}>
						<Card>
							<CardContent>
								<Hidden smDown>
									<Button
										type="submit"
										fullWidth
										variant="contained"
										color="primary"
										className={classes.submit}
									>
										Save
									</Button>
								</Hidden>
								<FormGroup row>
									<FormControlLabel
										control={
											<Switch
												color="primary"
												checked={page.published}
												onChange={onChangePublished}
												name="published"
											/>
										}
										label={
											page.published ? (
												<Typography color="primary">Published</Typography>
											) : (
												<Typography color="secondary">Draft</Typography>
											)
										}
									/>
								</FormGroup>
							</CardContent>
						</Card>
					</Grid>
				</Grid>
			</form>
		</>
	);
}
